import { render, staticRenderFns } from "./LabelPrint.vue?vue&type=template&id=586f47e8&scoped=true&"
import script from "./LabelPrint.vue?vue&type=script&lang=js&"
export * from "./LabelPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586f47e8",
  null
  
)

export default component.exports